import React, { useEffect, useState } from 'react';
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';
import ScienceBackground from '../../components/layout/ScienceBackground';

const faqData = [
  {
    q: "How do I register for a class?",
    a: "You can register by clicking the 'Register Now' button on the Courses page and filling out the application form. We will contact you via WhatsApp to confirm your enrollment."
  },
  {
    q: "ඔන්ලයින් පන්ති (Online Classes) සඳහා සම්බන්ධ වන්නේ කෙසේද?",
    a: "ඔබ ලියාපදිංචි වීමෙන් පසු ඔබට ලැබෙන WhatsApp පණිවිඩය හරහා zoom link එකක් සහ සම්බන්ධ වීමේ උපදෙස් ලබා දෙනු ඇත."
  },
  {
    q: "WebSite එකට පුරනය(Login) වන ආකාරය කුමක්ද?",
    a: "ප්‍රධාන මෙනුවේ ඇති 'Student Login' බොත්තම ක්ලික් කිරීමෙන් හෝ අපගේ YouTube මාර්ගෝපදේශක වීඩියෝව නැරඹීමෙන් ඔබට නිවැරදිව පද්ධතියට ලොග් විය හැක."
  },
  {
    q: "Are the classes conducted in Sinhala or English medium?",
    a: "We proudly conduct all Science classes in both Sinhala and English mediums to cater to all syllabuses."
  },
  {
    q: "මට ලියාපදිංචි වීමේදී ගැටළුවක් ඇති වුවහොත් කුමක් කළ යුතුද?",
    a: "ගැටලුව ඇති තැන screenshot එකක් සමඟ 0740251710 අංකයට අනිවාර්යයෙන් WhatsApp පණිවිඩයක් එවන්න."
  }
];

const FaqItem = ({ q, a }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={`overflow-hidden border border-slate-200 rounded-2xl transition-all duration-300 ${isOpen ? 'bg-white shadow-lg shadow-orange-500/5 border-orange-200' : 'bg-white hover:border-slate-300 shadow-sm'}`}>
      <button 
        onClick={() => setIsOpen(!isOpen)} 
        className="w-full px-6 py-5 text-left flex items-center justify-between font-bold text-slate-800 transition-colors focus:outline-none"
      >
        <span className="font-sinhala pr-8 text-lg">{q}</span>
        <span className={`w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${isOpen ? 'bg-orange-500 text-white rotate-180 shadow-md shadow-orange-500/30' : 'bg-slate-100 text-slate-400'}`}>
          ▼
        </span>
      </button>
      <div className={`transition-all duration-500 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="px-6 pb-6 pt-2 text-slate-600 leading-relaxed font-sinhala border-t border-slate-100 mt-2 mx-4">
          <div className="pt-4">{a}</div>
        </div>
      </div>
    </div>
  );
};

const Faq = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="font-sans bg-slate-50 min-h-screen text-slate-800 overflow-x-hidden selection:bg-rose-500 selection:text-white relative flex flex-col">
      <ScienceBackground />
      <Navbar />
      
      <div className="relative z-10 flex-grow pt-32 pb-24 px-6 md:px-12 max-w-4xl mx-auto w-full">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-1.5 rounded-full bg-violet-100 text-violet-600 font-bold text-sm tracking-wide mb-4 border border-violet-200">
            Got Questions? 🤔
          </div>
          <h1 className="text-4xl md:text-5xl font-black uppercase tracking-tight text-slate-800 mb-6 drop-shadow-sm font-sans">
            Frequently Asked <span className="text-violet-500">Questions</span>
          </h1>
          <p className="text-lg text-slate-500 font-medium max-w-xl mx-auto">
            Find answers to the most common questions about our platform, registrations, classes, and support.
          </p>
        </div>

        <div className="space-y-4">
          {faqData.map((item, idx) => (
            <FaqItem key={idx} q={item.q} a={item.a} />
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Faq;
